import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Modal} from 'react-bootstrap';
import ModalContainer from '../containers/ModalContainer';
import PresetNumberContainer from '../containers/PresetNumberContainer';
import uniqueId from 'lodash/uniqueId';

export default class PresetNumberModalButton extends Component {
    static propTypes = {
        preset: PropTypes.object,
        presetId: PropTypes.number,
        editableName: PropTypes.bool,
        showMatchingWarning: PropTypes.bool,
        buttonTitle: PropTypes.string,
        buttonLabel: PropTypes.any,
        modalTitle: PropTypes.string,
        buttonProps: PropTypes.object,
    };

    render() {
        const {buttonLabel, buttonTitle, modalTitle, buttonProps, ...rest} = this.props;

        return (
            <ModalContainer name={`makePresetModal-${uniqueId()}`}>{(isOpen, openModal, closeModal) => (
                <Button title={buttonTitle} onClick={openModal} className="make-preset" {...buttonProps}>
                    {buttonLabel}
                    <Modal show={isOpen} onHide={closeModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>{modalTitle}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <PresetNumberContainer
                                onCancel={closeModal}
                                onSubmit={closeModal}
                                {...rest}
                            />
                        </Modal.Body>
                    </Modal>
                </Button>
            )}</ModalContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PresetNumberModalButton.js